import { PrintingPreferencesView } from "../printing-preferences/printing-preferences-view";

export function LabelPrintPreferences() {
  return <PrintingPreferencesView />;
}
